export { default } from './Indicator.container';


// WEBPACK FOOTER //
// ./src/components/shared/Indicator/index.tsx